import CustomInput from "../protected-page/components/CustomInput";

export const Field = ({
  label,
  disabled,
  placeholder,
  value,
  onChange,
  required,
  type = "text",
}) => (
  <div>
    <label className="block text-sm text-gray-600 mb-1">
      {label}
      {required && <span className="text-red-500 ml-1">*</span>}
    </label>
    <CustomInput
      type={type}
      disabled={disabled}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
    />
  </div>
);
